import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  Income = 'Income',
}

export const queryKeys = {
  income: (clientId: string) => [QueryFeature.Profile, QueryKey.Income, clientId],
};
